/*
 * Copyright © Scale Microgrid Solutions Operating, LLC [2023].
 * All rights reserved.
 *
 * SPDX-FileCopyrightText: ©2023 Scale Microgrid Solutions Operating, LLC <legal@scalemicrogrids.com>
 */

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import AlarmCircle from "./AlarmCircle";
import { ALARM_SEVERITIES, normalizeAlarmSeverity } from "../../../lib/AlarmColors";

// One row per severity, active rows before resolved ones, empty rows omitted.
const summarizeAlarms = (alarms) =>
  [false, true]
    .flatMap((resolved) =>
      ALARM_SEVERITIES.map((severity) => ({
        severity,
        resolved,
        count: alarms.filter(
          (alarm) =>
            normalizeAlarmSeverity(alarm.alarm_type) === severity &&
            Boolean(alarm.stop_time) === resolved,
        ).length,
      })),
    )
    .filter((row) => row.count > 0);

const AlarmSummary = ({ alarms }) => (
  <Box display="flex" flexDirection="column" width="100%">
    {summarizeAlarms(alarms).map(({ severity, resolved, count }) => (
      <Box
        key={severity + (resolved ? "-resolved" : "-active")}
        display="flex"
        flexDirection="row"
        alignItems="baseline"
        mt="0.25em"
        mb="0.25em"
      >
        <AlarmCircle alarmSeverity={severity} resolved={resolved} />
        <Box pl="0.5em">
          <Typography variant="caption">
            {count} {severity} Alarms
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
);

AlarmSummary.propTypes = {
  alarms: PropTypes.array,
};

export default AlarmSummary;
